var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"webrtc-streamer-container"},[_c('video',{ref:"vjsVideo",staticClass:"video-js",attrs:{"id":"vjsVideo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }